import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ResetCode from "../../Components/UserComponents/ResetCode.jsx";

const ResetCodePage = () => {
  const alreadyConnected = JSON.parse(localStorage.getItem("clt"));
  const navigate = useNavigate();
  useEffect(() => {
    if (alreadyConnected !== null) {
      navigate("/espaceClient");
    }
  }, []);
  return <div><ResetCode type={'client'}/></div>;
};

export default ResetCodePage;
